"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gsap_1 = __importDefault(require("gsap"));
class SentenceManager {
    constructor(signals) {
        this.signals = signals;
        this.el = document.createElement('div');
        this.el.className = 'texts';
        document.body.appendChild(this.el);
        signals.showText.add(this.show.bind(this));
        signals.hideText.add(this.hide.bind(this));
    }
    show(txt, color) {
        const node = document.createElement('div');
        node.className = 'text';
        node.innerText = txt;
        if (color === 'white')
            node.style.color = 'rgba(255, 255, 255, .7)';
        this.el.appendChild(node);
        gsap_1.default.to(node, {
            duration: 1,
            delay: 0.1,
            opacity: 1,
            y: 0,
            ease: 'sine.inOut',
        });
    }
    hide() {
        const node = this.el.childNodes[0];
        if (!node)
            return;
        gsap_1.default.to(node, {
            duration: 0.5,
            opacity: 0,
            y: -5,
            ease: 'power2.inOut',
            onComplete: () => {
                this.el.removeChild(node);
            },
        });
    }
}
exports.default = SentenceManager;
